<template>
  <div class="circle">
    <svg width="140" viewBox="0 0 220 220" xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(110,110)">
        <circle r="100" class="e-c-base" />
        <g transform="rotate(-90)">
          <circle r="100" class="e-c-progress" />
          <g id="e-pointer">
            <circle cx="100" cy="0" r="8" class="e-c-pointer" />
          </g>
        </g>
      </g>
    </svg>
    <div class="display-remain-time"></div>
  </div>
</template>
<script>
export default {
  props: {
    countdownTime: {
      type: Number,
      default: 20
    },
    timeLeftProps: {
      type: Number,
      default: 20
    }
  },
  data() {
    return {
      timeLeft: null
    };
  },
  mounted() {
    let progressBar = document.querySelector(".e-c-progress");
    let pointer = document.getElementById("e-pointer");
    let perimeter = Math.PI * 2 * 100;
    progressBar.style.strokeDasharray = perimeter;
    // recalculate arc length in remaining time
    function update(value, timePercent) {
      let offset = -perimeter - (perimeter * value) / timePercent;
      progressBar.style.strokeDashoffset = offset;
      pointer.style.transform = `rotate(${(360 * value) / timePercent}deg)`;
    }
    const displayOutput = document.querySelector(".display-remain-time");
    let intervalTimer;
    let timeLeft;
    let wholeTime = this.countdownTime;
    let isStarted = false;
    timer(this.timeLeftProps);
    displayTimeLeft(this.timeLeftProps);
    const self = this;
    //calculate the remaining paper
    function timer(seconds) {
      let remainTime = Date.now() + seconds * 1000;
      displayTimeLeft(seconds);
      intervalTimer = setInterval(function() {
        timeLeft = Math.round((remainTime - Date.now()) / 1000);
        if (timeLeft < 0) {
          clearInterval(intervalTimer);
          self.$emit("time-up");
          isStarted = false;
          displayTimeLeft(wholeTime);
          return;
        }
        self.timeLeft = timeLeft;
        displayTimeLeft(timeLeft);
      }, 1000);
    }
    function displayTimeLeft(timeLeft) {
      let seconds = timeLeft;
      let displayString = `${seconds < 10 ? "0" : ""}${seconds}`;
      displayOutput.textContent = displayString;
      update(timeLeft, wholeTime);
    }
  }
};
</script>
<style lang="scss" scoped>
.circle {
  position: relative;
  width: 140px;
  margin: 0;
  .display-remain-time {
    position: absolute;
    font-weight: 500;
    font-size: 50px;
    color: #7b79c9;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .e-c-base {
    fill: none;
    stroke: #b6b6b6;
    stroke-width: 18px;
  }
  .e-c-progress {
    fill: none;
    stroke: #7b79c9;
    stroke-width: 21px;
    transition: stroke-dashoffset 0.7s;
  }
  #e-pointer {
    transition: transform 0.7s;
    .e-c-pointer {
      fill: #fff;
      stroke: #7b79c9;
      stroke-width: 0;
    }
  }
}
</style>
